<app-cookie>
</app-cookie>

<div
  #page
>
  <mat-sidenav-container [class.open]="sideNav.opened">
    <nav
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="container"
    >
      <button
        class="main-menu-burger"
        fxHide.gt-sm
        [class.open]="sideNav.opened"
        (click)="toggleSidenav()"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </button>
      <a
        routerLink="/"
        fxLayout="row"
        fxLayoutAlign="center center"
        class="logo"
      >
        <img src="/assets/icons/logo.png" alt="logo">
        <h1>
          Logo
        </h1>
      </a>
      <mat-nav-list
        fxHide
        fxShow.gt-sm
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <mat-list-item
          routerLinkActive="active"
          routerLink="/"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          acasă
        </mat-list-item>
        <mat-list-item
          *ngIf="agencyService.agency.web_page_types.indexOf('about_us') != -1"
          routerLinkActive="active"
          routerLink="despre-noi"
        >
          despre noi
        </mat-list-item>
        <mat-list-item
          routerLinkActive="active"
          routerLink="portofoliu"
        >
          portofoliu
        </mat-list-item>
        <mat-list-item
          routerLinkActive="active"
          routerLink="apartamente"
        >
          locuințe
        </mat-list-item>
        <mat-list-item
          routerLinkActive="active"
          routerLink="servicii"
        >
          servicii
        </mat-list-item>
        <mat-list-item
          routerLinkActive="active"
          routerLink="parteneri"
        >
          parteneri
        </mat-list-item>
        <mat-list-item
          routerLinkActive="active"
          routerLink="contact"
        >
          contact
        </mat-list-item>
      </mat-nav-list>
      <div
        fxHide
        fxShow.gt-md
        fxLayout="row"
        fxLayoutAlign="center"
        class="social-icons-menu-container"
      >
        <ng-template
          [ngIf]="agencyService.agency.social_header_visibility == true"
        >
          <app-social-icons-base
            fxHide
            fxShow.gt-md
            [isTooltipBelow]="true"
          >
          </app-social-icons-base>
        </ng-template>
      </div>
    </nav>
  </mat-sidenav-container>
  <mat-sidenav #sideNav>
    <mat-nav-list>
      <div
        #navList
      >
        <mat-list-item
          (click)="toggleSidenav()"
          routerLinkActive="active"
          routerLink="/"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          acasă
        </mat-list-item>
        <mat-list-item
          *ngIf="agencyService.agency.web_page_types.indexOf('about_us') != -1"
          (click)="toggleSidenav()"
          routerLinkActive="active"
          routerLink="despre-noi"
        >
          despre noi
        </mat-list-item>
        <mat-list-item
          (click)="toggleSidenav()"
          routerLinkActive="active"
          routerLink="portofoliu"
        >
          portofoliu
        </mat-list-item>
        <mat-list-item
          (click)="toggleSidenav()"
          routerLinkActive="active"
          routerLink="apartamente"
        >
          locuințe
        </mat-list-item>
        <mat-list-item
          (click)="toggleSidenav()"
          routerLinkActive="active"
          routerLink="servicii"
        >
          servicii
        </mat-list-item>
        <mat-list-item
          (click)="toggleSidenav()"
          routerLinkActive="active"
          routerLink="parteneri"
        >
          parteneri
        </mat-list-item>
        <mat-list-item
          (click)="toggleSidenav()"
          routerLinkActive="active"
          routerLink="contact"
        >
          contact
        </mat-list-item>
      </div>
    </mat-nav-list>
    <app-social-icons-base [isTooltipBelow]="true"></app-social-icons-base>
  </mat-sidenav>

  <router-outlet></router-outlet>
</div>

<app-footer-vaunt>
</app-footer-vaunt>



// WEBPACK FOOTER //
// ./src/app/app.component.html